<template>
    <div class="js-author-detail">
        <div class="content-header">
            <ol class="breadcrumb">
                <li>
                    <router-link :to="{ name: 'valueConfigList' }">参数配置</router-link>
                </li>
                <li class="active">(添加/修改)</li>
            </ol>
        </div>
        <div class="content-from">
            <el-form ref="formName" :model="saveModel" :rules="rules">
                <el-form-item label="参数值" prop="value">
                    <el-input v-model="saveModel.value"></el-input>
                </el-form-item>
                <el-form-item label="参数名" prop="remark">
                    <el-input v-model="saveModel.remark"></el-input>
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="saveValueConfig">保存</el-button>
                    <el-button @click="resetForm('formName')">重置</el-button>
                    <el-button @click="$router.back(-1)">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>

export default {
    data() {
        return {
            valueConfigId: '',
            saveModel: {
                value: '',
                remark: ''
            },
            rules: {
                value: [
                    { required: true, message: "请输入参数值", trigger: "blur" }
                ]
            },
        }
    },
    created() {
        var _this = this;
        _this.valueConfigId = _this.$route.query.valueConfigId;
        if (_this.valueConfigId) {
            _this.detailValueConfig();
        }
    },
    methods: {
        detailValueConfig() {
            var _this = this;
            _this.$common.my_ajax({
                url: '/valueConfig/detailValueConfig',
                data: {
                    valueConfigId: _this.valueConfigId
                },
                success: function(response) {
                    _this.saveModel = response.item;
                }
            });
        },
        saveValueConfig() {
            var _this = this;
            _this.$refs['formName'].validate((valid) => {
                if (valid) {
                    _this.$common.my_ajax({
                        url: '/valueConfig/saveValueConfig',
                        data: _this.saveModel,
                        success: function(response) {
                            _this.$message({
                                message: '保存成功',
                                type: 'success',
                                duration: 1000,
                                onClose: function() {
                                    _this.$router.push({ name: 'valueConfigList' });
                                }
                            });
                        }
                    });
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });
        },
        resetForm(formName) {
            this.$refs[formName].resetFields();
        },
    }
}
</script>